<ng-container *ngIf="ready">
    <div class="bg-white">
        <mat-card appearance="outlined">
            <div class="mainBody">
                <div class="one-column">
                    <form onkeypress="return event.keyCode != 13;">
                        <div class="mainBody">
                            <p><strong>Conexión con trazabilidad<app-help key='Stock1'></app-help></strong></p>
                            <hr>
                            <div class="flex-container-column">
                                <div>
                                    <app-input inputType="text" placeholder="Token" name="userStock.token"
                                        [isRequired]="true" [(ngModel)]="userStock.token"></app-input>
                                </div>
                            </div>
                            <div *ngIf="userStock.token == null">  
                                <button mat-stroked-button (click)="generarToken()">
                                    Generar token
                                </button> 
                            </div>
                            <div *ngIf="userStock.token != null"> 
                                <button mat-stroked-button (click)="generarToken()">
                                    Actualizar token
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div> 
        </mat-card>
    </div> 
</ng-container>